'use client';

import type { ReactElement } from 'react';
import { ColorPickerPopover } from './color-picker-popover';
import { HStack } from './h-stack';

type ColorRowProps = {
  label: string;
  value: string;
  isOpen: boolean;
  onSwatchClick: () => void;
  onClose: () => void;
  onChange: (hex: string) => void;
};

/** A labelled swatch row that opens a `ColorPickerPopover` when clicked. */
export const ColorRow = ({
  label,
  value,
  isOpen,
  onSwatchClick,
  onClose,
  onChange,
}: ColorRowProps): ReactElement => (
  <div className="relative">
    <HStack align="center" gap={3} className="px-4 py-3 rounded-[10px] border border-border">
      <button
        type="button"
        onClick={onSwatchClick}
        className="size-8 rounded-md shrink-0 border border-black/10 focus:outline-none focus:ring-2 focus:ring-surface-inverse focus:ring-offset-1"
        style={{ backgroundColor: value }}
        aria-label={`Open colour picker for ${label}`}
      />
      <span className="text-sm text-fg-muted flex-1">{label}</span>
      <span className="text-sm font-mono text-fg">{value}</span>
    </HStack>
    {isOpen && (
      <ColorPickerPopover label={label} value={value} onChange={onChange} onClose={onClose} />
    )}
  </div>
);
